import { render, staticRenderFns } from "./RegoType.vue?vue&type=template&id=03cdc394&scoped=true&"
import script from "./RegoType.vue?vue&type=script&lang=js&"
export * from "./RegoType.vue?vue&type=script&lang=js&"
import style0 from "./RegoType.vue?vue&type=style&index=0&id=03cdc394&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03cdc394",
  null
  
)

export default component.exports